import BillWithMainContract from "./BillWithMainContract";
import Confirm from "./Confirm";

export default {
  BILL_WITH_MAIN_CONTRACT: BillWithMainContract,
  CONFIRM: Confirm,
};
